module.exports = __webpack_public_path__ + "application/directives/copy-clipboard/copy-clipboard.template.html";